import {routes as login} from './domains/login'
import {routes as pessoal} from './domains/pessoal'
import {routes as academico} from './domains/academico'
import {routes as financeiro} from './domains/financeiro'
import {routes as vestibular} from './domains/vestibular'
import {routes as avaliacao} from './domains/avaliacao'

export default [
  ...login,
  ...pessoal,
  ...academico,
  ...financeiro,
  ...vestibular,
  ...avaliacao
]



// WEBPACK FOOTER //
// ./src/app/routes.js